import { useEffect, useState } from "react"

export function useLocation() {
  const [location, setLocation] = useState<Location | null>(null)
  useEffect(() => {
    const handler = () => setLocation(window.location)
    handler()
    window.addEventListener("popstate", handler)
    return () => window.removeEventListener("popstate", handler)
  }, [])
  return location
}
